import React from "react";
import Parse from "parse";
import { useState, useEffect } from "react";
import { Image, Box, Input, Text, Flex } from "@chakra-ui/react";
import imageUp from "../user.png";

function ShowAvatarProfile() {
  async function fetchUser() {
    const currentUser = Parse.User.current();
    setUser(currentUser);
    if (!currentUser.get("current_job")) {
      setMetier(currentUser.get("type"));
    } else {
      setMetier(currentUser.get("current_job"));
    }
    setPoste(currentUser.get("situation"));
    return currentUser;
  }

  async function saveInfos() {
    const currentUser = Parse.User.current();
    const m = currentUser.get("current_job");
    const s = currentUser.get("situation");
    if (m != metier || s != poste) {
      currentUser.set("current_job", metier);
      currentUser.set("situation", poste);

      currentUser.save().then(
        (currentUser) => {},
        (error) => {
          alert(
            "Failed to update user informations, with error code: " +
              error.message
          );
        }
      );
    }
  }

  const [metier, setMetier] = useState("");
  const [poste, setPoste] = useState("");
  const [user, setUser] = useState();

  useEffect(() => {
    fetchUser();
  }, []);

  //   useEffect(() => {
  //     saveInfos();
  //   }, [metier, poste]);

  return (
    <div>
      {user ? (
        <div>
          <Box
            display={"flex"}
            borderWidth="8px"
            boxShadow="2xl"
            borderRadius="full"
            borderColor="#AEDFFF"
            w="96px"
            marginBottom={4}
          >
            <Image
              src={user.get("avatar") ? user.get("avatar").url() : imageUp}
              alt={imageUp}
              borderRadius="full"
              boxSize="80px"
            />
            <Flex direction={"column"} marginStart={10}>
              <Text
                fontFamily={"Sofia Pro"}
                fontSize="xl"
                fontWeight={"bold"}
                color="black"
                align={"left"}
              >
                {user.get("prenom")}
              </Text>
              <Text
                fontFamily={"Sofia Pro"}
                fontSize="xl"
                fontWeight={"bold"}
                color="black"
                align={"left"}
              >
                {user.get("nom")}
              </Text>
            </Flex>
          </Box>

          <Input
            placeholder="Metier"
            bg="white"
            id="Metier"
            borderRadius="100px"
            value={metier}
            onBlur={saveInfos}
            onChange={(e) => setMetier(e.target.value)}
            errorBorderColor="red.300"
            marginBottom={"20px"}
          />

          <Input
            placeholder="Poste"
            bg="white"
            id="Poste"
            borderRadius="100px"
            value={poste}
            onChange={(e) => setPoste(e.target.value)}
            onBlur={saveInfos}
            errorBorderColor="red.300"
            marginBottom={"20px"}
          />
        </div>
      ) : (
        ""
      )}
    </div>
  );
}

export default ShowAvatarProfile;
